import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
// import throttle from 'lodash.throttle';

import { Link } from 'gatsby';

import SocialButtons from '../social-buttons';
import Nav from './nav';
// import ThemeToggle from './theme-toggle';
import HeaderToggle from './header-toggle';

// const StyledThemeToggle = styled(ThemeToggle)`
//   grid-area: theme-toggle;
// `;

const StyledTitleLink = styled(Link)`
  grid-area: title;
  text-align: center;
  color: var(--text-primary);
`;

const StyledSocialButtons = styled(SocialButtons)`
  grid-area: social;
`;

const StyledNav = styled(Nav)`
  grid-area: nav;
  max-width: min-content;
  justify-self: center;
`;

const StyledPrivacyLink = styled(Link)`
  grid-area: privacy;
`;

const StyledHiddenMenuToggle = styled(HeaderToggle)`
  position: fixed;
  right: var(--spacer);
  top: var(--spacer);
  z-index: 2;

  @media (min-width: 900px) {
    display: none;
    visibility: hidden;
  }
`;

const StyledHeader = styled.div`
  position: fixed;
  top: 0;
  z-index: 1;
  width: 100vw;
  height: 100vh;

  display: grid;
  padding: var(--spacer);
  gap: var(--spacer);
  margin-bottom: 0;

  justify-content: center;
  justify-items: center;
  align-items: center;

  grid-template-columns: 1fr;

  @media (max-width: 900px) {
    ${StyledSocialButtons}, ${StyledNav}, ${StyledPrivacyLink} {
      ${({ isCollapsed }) => (isCollapsed ? 'display: none;' : '')}
    }
  }

  @media only screen and (min-width: 900px) {
    left: 0;
    width: 16rem;
    display: grid;

  }

  box-shadow: var(--glass-glow);
  border: var(--glass-border);
  background-color: var(--glass-bg);
  backdrop-filter: var(--glass-filter);

  @supports not ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background-color: var(--bg);
  }

  grid-template-areas:
    "title "
    "social"
    "nav"
    "privacy";

  &.open {
    display: grid;
    position: fixed;
  }

  @media (max-width: 900px) {
    transform: translateX(-100%);
    transition: transform 500ms ease-in;

    &.open {
      transform: translateX(0);
    }
  }

  @media (min-width: 900px) {
    grid-template-columns: 1fr;
    justify-items: center;
    align-content: center;

    visibility: visible;
  }
`;

export default function Header() {
  const [isCollapsed, setCollapsed] = useState(true);

  return (
    <>
      <StyledHeader
        className={!isCollapsed ? 'open' : ''}
        isCollapsed={isCollapsed}
      >
        <StyledPrivacyLink to="/privacy">Datenschutz</StyledPrivacyLink>

        <StyledSocialButtons
          onClick={() => {
            setCollapsed(false);
          }}
        />

        <StyledTitleLink to="/">
          <h2>Roman Kollatschny</h2>
        </StyledTitleLink>
      </StyledHeader>

      <StyledHiddenMenuToggle
        onClick={() => {
          setCollapsed((v) => !v);
        }}
        isOpen={!isCollapsed}
      />
    </>
  );
}
